import { SVGProps } from 'react';
export const Wallet = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="100%"
        height="100%"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 48 48"
        {...props}
    >
        <path
            fill="white"
            fillRule="evenodd"
            d="M31.095 10.022c.302.045.565.153.812.288l.035.02.034.021c.527.345.892.866 1.03 1.44.016.065.022.12.023.133v.001a1.558 1.558 0 0 1 .01.143l.006.206a324.05 324.05 0 0 1 .018 2.486l.003 1.82.001.821-2 .001v-.82a864.906 864.906 0 0 0-.014-3.652 60.28 60.28 0 0 0-.01-.725.436.436 0 0 0-.135-.161.771.771 0 0 0-.106-.043s-.008-.002-.028 0a.772.772 0 0 0-.064.006l-.52.172a4377.736 4377.736 0 0 0-6.44 2.138c-3.607 1.2-7.314 2.443-7.915 2.673-.535.21-1.027.37-1.46.508l-.25.078c-.331.104-.609.19-.86.284-.624.23-.839.41-.957.627l-1.756-.958c.476-.874 1.275-1.271 2.021-1.546.303-.112.64-.217.975-.322l.226-.07c.42-.133.862-.278 1.333-.464l.008-.003c.645-.247 4.428-1.514 8.003-2.705a3967.193 3967.193 0 0 1 6.443-2.138l.594-.197.314.95-.314-.95.067-.022.068-.012c.236-.043.505-.072.805-.028Z"
            clipRule="evenodd"
        />
        <path
            fill="white"
            fillRule="evenodd"
            d="M12.653 18.358a.653.653 0 0 0-.653.653v15.976c0 .36.292.653.653.653h22.565c.36 0 .653-.292.653-.653V19.011a.653.653 0 0 0-.653-.653H12.653ZM10 19.011a2.653 2.653 0 0 1 2.653-2.653h22.565a2.653 2.653 0 0 1 2.653 2.653v15.976a2.653 2.653 0 0 1-2.653 2.653H12.653A2.653 2.653 0 0 1 10 34.987V19.011Z"
            clipRule="evenodd"
        />
        <path
            fill="white"
            fillRule="evenodd"
            d="M26.109 26.999c0-2.422 1.942-4.416 4.36-4.416h5.245a2.16 2.16 0 0 1 2.157 2.168h-2c0-.104-.076-.168-.157-.168h-5.245c-1.284 0-2.36 1.07-2.36 2.416 0 1.347 1.076 2.416 2.36 2.416h5.245a.167.167 0 0 0 .157-.168h2a2.166 2.166 0 0 1-2.157 2.168h-5.245c-2.418 0-4.36-1.994-4.36-4.416Z"
            clipRule="evenodd"
        />
    </svg>
);
